module.exports = __webpack_public_path__ + "img/tab07.d1210c97.png";